export function generateUniqueId(): string {
  const timestamp = Date.now().toString(36);
  const array = new Uint32Array(2);
  crypto.getRandomValues(array);
  const random = Array.from(array, num => num.toString(36)).join('');
  return timestamp + random;
}

export function isBackForwardNavigation(window): boolean {
  const perfNavList = window?.performance?.getEntriesByType(
    'navigation'
  ) as PerformanceNavigationTiming[];

  return perfNavList?.length > 0 && perfNavList[0].type === 'back_forward';
}

export function getCurrentFragment(
  windowOrGlobalThis: Window | typeof globalThis
): string {
  const hash = windowOrGlobalThis.location.hash;

  return hash ? hash.substring(1) : '';
}

export function flattenParams<T>(params: T) {
  const result = {};

  for (const key of Object.keys(params)) {
    if (
      typeof params[key] === 'object' &&
      !Array.isArray(params[key]) &&
      params[key] !== null
    ) {
      for (const subKey of Object.keys(params[key])) {
        if (!params[key][subKey]) continue;

        result[`${key}.${subKey}`] = params[key][subKey];
      }
    } else {
      result[key] = params[key];
    }
  }

  return result;
}
